import { useAuthenticationContext } from 'components/providers/authentication-provider';
import {
  FRIEND_STATUS,
  FriendStatus,
  FriendStatusData,
  FriendStatusVariables,
  UserUsers,
} from 'graphql/main/queries';
import { useFlexQuery } from 'hooks';
import { isEqual, isString } from 'lodash';
import { createContext, useContext } from 'react';
import ChatButton from './chat-button';
import FriendButton from './friend-button';

interface Props {
  user?: UserUsers;
}
interface FriendStatusContext {
  user?: UserUsers;
  friendStatus?: FriendStatus;
  refetchFriendStatus?: () => void;
}

const FriendStatusContext = createContext<FriendStatusContext>({});
export const useFriendStatus = () => useContext(FriendStatusContext);

const FriendActions = ({ user }: Props) => {
  const { currentUser } = useAuthenticationContext();
  const { data: friendStatusData, refetch: refetchFriendStatus } = useFlexQuery<
    FriendStatusData,
    FriendStatusVariables
  >('main', FRIEND_STATUS, {
    variables: {
      userId: user && isString(user?.id) ? user.id : '',
    },
    skip: !isString(user?.id) || !currentUser,
  });
  const { friendStatus } = friendStatusData ?? {};

  return user && !isEqual(user.id, currentUser?.id) ? (
    <FriendStatusContext.Provider value={{ user, friendStatus, refetchFriendStatus }}>
      <div className='flex w-full space-x-[12px]'>
        <FriendButton />
        <ChatButton />
      </div>
    </FriendStatusContext.Provider>
  ) : null;
};

export default FriendActions;
